import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import { StyledHeaderButton, StyledBurgerButton, TextButton } from './styles';
import RoutesUtils from '../../../../utils/routes';
import { MenuItemType } from '../../../../typings/menu';
import UserAgentUtils from '../../../../utils/userAgent';
import Tooltip from '../../../Tooltip';
import { openCustomItem, requestOpenLeftSideMenu } from '../../../../containers/MenuManager/actions';

import { Translate } from 'react-redux-i18n';

interface HeaderButtonProps {
	icon?: string;
	label?: string;
	type?: MenuItemType;
	target?: string;
	dispatch: Dispatch<StoreState>;
	isMultiApp: boolean;
	iconSrc: string;
	isActive: boolean;
}

const HeaderButton = (props: HeaderButtonProps) => {
	const handleClick = () => {
		const { target, type, dispatch } = props;

		switch (type) {
			case MenuItemType.Link:
			case MenuItemType.Asset:
			case MenuItemType.Folder:
			case MenuItemType.Page:
				dispatch(openCustomItem(type, target as string));
				break;
			case MenuItemType.BurgerButton:
				dispatch(requestOpenLeftSideMenu());
				break;
			default:
				RoutesUtils.historyPush(target as string);
				break;
		}
	};

	const getImgElement = () => {
		const { icon, iconSrc } = props;

		if (icon) {
			if (iconSrc) {
				return <img src={iconSrc} />;
			} else if (icon.includes('iconset')) {
				return Utils.getSvgIcon(icon);
			}
		}
		return '';
	};

	const { icon, label, type, isMultiApp, isActive } = props;
	const tooltipId = Utils.generateId();
	const isCustom = type === MenuItemType.Link || type === MenuItemType.Asset || type === MenuItemType.Page || type === MenuItemType.Folder;
	const StyledButton = type !== MenuItemType.BurgerButton ? StyledHeaderButton : StyledBurgerButton;

	return (
		<StyledButton
			onClick={handleClick}
			data-tip={true}
			data-for={tooltipId}
			isMultiApp={isMultiApp}
			isActive={isActive}
		>
			{icon &&
				getImgElement()
			}
			{!icon && label &&
				<TextButton><Translate value={label} /></TextButton>
			}
			{(UserAgentUtils.isDesktop() && label) &&
				<Tooltip id={tooltipId} text={label} isCustom={isCustom} />
			}
		</StyledButton>
	);
};

export default HeaderButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/HeaderButton/index.tsx